export const setStatisticsTaskCategorySelected = selected => {
  return {
    type: "SET_STATISTICS_TASK_CATEGORY_SELECTED",
    selected
  };
};

export const setStatisticsYears = years => {
  return {
    type: "SET_STATISTICS_YEARS",
    years
  };
};

export const setYearSelectedItem = selected => {
  return {
    type: "SET_STATISTICS_YEARS_SELECTED",
    selected
  };
};

export const fetchTaskTypeStatistics = data => ({
  type: "FETCH_TASK_TYPES_STATISTICS",
  payload: data
});



// WEBPACK FOOTER //
// ./src/actions/actions/statistics.js